export const TRIGGERS_VALUE_TO_LABEL = ['first_message', 'any_user_message', 'post_message'];

export const TRIGGER_LABEL_KEYS: Record<string, string> = {
  first_message: 'rules.editor.triggers.first_message',
  any_user_message: 'rules.editor.triggers.any_user_message',
  post_message: 'rules.editor.triggers.post_message',
};
